export { default } from './FormCulturalOrganization.vue'
